import { type Dispatch, type SetStateAction } from "react";
import { usePersistentStorage } from "./utils";

/**
 * Same as useState, but saves the state in session storage.
 * @param queryKey the key saved in session storage
 * @param initialState string initial state, or a function that returns a string
 */
export function useLocalStorage<T = undefined>(
    queryKey: string
): [T | undefined, Dispatch<SetStateAction<T | undefined>>];
export function useLocalStorage<T>(
    querykey: string,
    initialState: T | (() => T)
): [T, Dispatch<SetStateAction<T>>];
export function useLocalStorage<T>(
    queryKey: string,
    initialState?: T | (() => T)
): [T, Dispatch<SetStateAction<T>>] {
    return usePersistentStorage("local", queryKey, initialState);
}
